import { createSlice } from "@reduxjs/toolkit";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    adminStatCounts: {
      workshops: 0,
      reservations: 0,
      services: 0,
      revenue: 0,
    },
  },
  reducers: {
    setAdminStatCounts: (state, action) => {
      const { key, value } = action.payload;
      if (state.adminStatCounts[key] !== undefined) {
        state.adminStatCounts[key] = value;
      }
    },
  },
});

export const { setAdminStatCounts, setViewTab } = dashboardSlice.actions;

export const selectAdminStatCounts = (state) => state.dashboard.adminStatCounts;

export default dashboardSlice.reducer;